import { render, staticRenderFns } from "./ProfileFilesTab.vue?vue&type=template&id=3a1de40e"
import script from "./ProfileFilesTab.vue?vue&type=script&lang=js"
export * from "./ProfileFilesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports